import { Beneficiary } from './Beneficiary';

class EditBeneficiaryRequestDTO {
  name: string;
  data: Beneficiary;

  constructor(name: string, data: Beneficiary) {
    this.name = name;
    this.data = data;
  }
}

export { EditBeneficiaryRequestDTO };
